import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    itemsSelector: String,
    filter: String
  }

  connect() {
    if ("URLSearchParams" in window) {
      const checkedValue = this.element.value;
      const url = new URL(window.location);
      const paramValue = url.searchParams.get(this.queryParam());
      if (paramValue && checkedValue !== paramValue) {
        this.element.value = paramValue;
        if (this.filterValue) {
          this.select();
        } else {
          this.onlySelect();
        }
      }
    }
  }

  select() {
    const value = this.element.value;
    const url = new URL(window.location);
    Array.from(document.getElementsByClassName(this.itemsSelectorValue)).forEach((element) => {
      element.classList.add("hidden");
    });
    value.split("-").forEach((type) => {
      Array.from(document.getElementsByClassName(type)).forEach((element) => {
        let filterValues = this.filterValue.split(" ");
        let notSeen = false;
        filterValues.forEach((value) => {
          notSeen = notSeen || (element.classList.contains(value) && (url.searchParams.get("toggle-" + value) === "yes"))
        })
        if (notSeen){
          //
        } else {
          element.classList.remove("hidden");
        }
      });
    });

    if ("URLSearchParams" in window) {
      url.searchParams.set(this.queryParam(), value);
      history.pushState(null, "", url);
    }
  }

  onlySelect() {
    const value = this.element.value;
    const url = new URL(window.location);
    Array.from(document.getElementsByClassName(this.itemsSelectorValue)).forEach((element) => {
      element.classList.add("hidden");
    });
    value.split("-").forEach((type) => {
      Array.from(document.getElementsByClassName(type)).forEach((element) => {
        element.classList.remove("hidden");
      });
    });

    if ("URLSearchParams" in window) {
      url.searchParams.set(this.queryParam(), value);
      history.pushState(null, "", url);
    }
  }

  queryParam() {
    return this.itemsSelectorValue;
  }
}
